import appModalConstants from '../actiontypes/appModal';

const initialState = {
  messageType: '',
  messageText: '',
  isLoading: false,
  loadingText: '',
  show: false,
  redirect: ''
};

function appModal(state = initialState, action) {
  switch (action.type) {
    case appModalConstants.LOADER_ON:
      return { ...state, isLoading: true, loadingText: action.loadingText };
    case appModalConstants.LOADER_OFF:
      return { ...state, isLoading: false, loadingText: '' };
    case appModalConstants.ERROR_MODAL_OPENED:
      return { ...state, show: true, messageText: action.message};
    case appModalConstants.ERROR_MODAL_CLOSED:
      return { ...state, show: false};
    case appModalConstants.SET_PATH_REDIRECT:
      return { ...state, show: true, redirect : action.redirect};
    default:
      return state;
  }
}
export default appModal;
